import { flagFactory } from '../icon';
import Svg from './hr.svg';

export default flagFactory(Svg);
